import "./component-library175.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "OfferTileList",
  props: {
    offers: {
      type: Array,
      required: true
    },
    spaces: { type: Boolean }
  },
  computed: {
    offersWithProduct() {
      return this.offers.filter((o) => {
        var _a;
        return (_a = o == null ? void 0 : o.product) == null ? void 0 : _a.articleNumber;
      }) || [];
    },
    wrapperClass() {
      return {
        "offer-tiles--spaces": this.spaces
      };
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _vm.offers.length > 0 ? _c("div", { staticClass: "offer-tiles", class: _vm.wrapperClass }, [_vm._t("beforeOfferTiles"), _vm._t("offerTileContainer", function() {
    return _vm._l(_vm.offersWithProduct, function(offer, index) {
      return _c("div", { key: offer.product ? offer.product.articleNumber : index, staticClass: "offer-tiles__item" }, [_vm._t("default", null, { "offer": offer, "index": index })], 2);
    });
  }), _vm._t("afterOfferTiles")], 2) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "bfd649dd",
  null,
  null
);
const offerTileList = __component__.exports;
export {
  offerTileList as default
};
